module.exports = __webpack_public_path__ + "static/media/icon.db927619.svg";